const NS = 'DoubleClick'; // jshint ignore:line

export default function DoubleClick(unregister) {
  "ngInject";

  const DblClickInterval = 400; //milliseconds
  let firstClickTime;
  let waitingSecondClick = false;

  return {
    restrict: 'A',
    link: function (scope, element, attrs) {

      var listeners = [];
      listeners.push(scope.$on('$destroy', () => {
        element.unbind('click', click);
        unregister(listeners);
      }));

      element.bind('click', click);

      function click(event) {
        event.preventDefault();

        if (!waitingSecondClick) {
          firstClickTime = Date.now();
          waitingSecondClick = true;

          setTimeout(function () {
            waitingSecondClick = false;
          }, DblClickInterval);
        } else {
          waitingSecondClick = false;

          const time = Date.now();
          const diff = time - firstClickTime;
          if (diff < DblClickInterval) {
            scope.$event = event;
            scope.$apply(attrs.doubleClick);
          }
        }
      }
    }
  };
}
